// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --ap-brand: var(--fc-brand, #5ea1d8);
  --ap-text: #212427;
  --ap-muted: #667085;
  --ap-border: #e4e7ec;
  --ap-bg: #ffffff;
  --ap-soft: #f6f8fa;
  display: block;
}

:host-context(.theme-dark-layout),
:host-context(body.theme-dark) {
  --ap-text: #e6e8eb;
  --ap-muted: #98a2b3;
  --ap-border: #2f3542;
  --ap-bg: #14171d;
  --ap-soft: #232834;
}

::ng-deep .content-activity-dialog .mat-mdc-dialog-container,
::ng-deep .content-activity-dialog .mat-dialog-container,
::ng-deep .content-activity-dialog .mat-mdc-dialog-surface {
  border-radius: 22px !important;
  overflow: hidden !important;
  padding: 0 !important;
}

.activity-panel {
  display: flex;
  flex-direction: column;
  max-height: 88vh;
  background: var(--ap-bg);
  color: var(--ap-text);
}

.activity-header {
  position: relative;
  padding: 20px 56px 14px 24px;
  border-bottom: 1px solid var(--ap-border);
}
.activity-header h2 {
  margin: 0;
  font-size: 20px !important;
  font-weight: 600;
  color: var(--ap-text);
  text-align: left;
}
.activity-header .subtitle {
  margin: 4px 0 0;
  font-size: 14px;
  color: var(--ap-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.activity-header .subtitle .kind {
  font-weight: 600;
  color: var(--ap-brand);
}
.activity-header .hint {
  margin: 4px 0 0;
  font-size: 12px;
  color: var(--ap-muted);
}
.activity-header button[mat-icon-button] {
  position: absolute;
  top: 12px;
  right: 12px;
  color: var(--ap-muted);
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.filters {
  display: flex;
  gap: 8px;
  padding: 12px 24px;
  border-bottom: 1px solid var(--ap-border);
  overflow-x: auto;
  scrollbar-width: none;
}
.filters::-webkit-scrollbar {
  display: none;
}

.filter {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid var(--ap-border);
  background: transparent;
  color: var(--ap-text);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.filter mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.filter .count {
  min-width: 18px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--ap-soft);
  font-size: 11px;
  font-weight: 600;
  text-align: center;
}
.filter:hover {
  border-color: var(--ap-brand);
}
.filter.active {
  background: var(--ap-brand);
  border-color: var(--ap-brand);
  color: #fff;
}
.filter.active .count {
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
}

.activity-body {
  padding: 16px 24px 24px;
  overflow-y: auto;
  flex: 1 1 auto;
  background: var(--ap-soft);
}

.state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 16px;
  text-align: center;
  color: var(--ap-muted);
  font-size: 14px;
}
.state mat-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
}
.state--error mat-icon {
  color: #f04438;
}
.state .retry {
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid var(--ap-brand);
  background: transparent;
  color: var(--ap-brand);
  font-weight: 600;
  cursor: pointer;
}

@media (max-width: 600px) {
  .activity-header {
    padding: 16px 48px 12px 16px;
  }
  .filters {
    padding: 10px 16px;
  }
  .activity-body {
    padding: 12px 12px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/content-activity-panel/content-activity-panel.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;;EAEE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAGE;;;EAGE,8BAAA;EACA,2BAAA;EACA,qBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;AADF;;AAIA;EACE,kBAAA;EACA,4BAAA;EACA,yCAAA;AADF;AAGE;EACE,SAAA;EACA,0BAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;AADJ;AAIE;EACE,eAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;AAII;EACE,gBAAA;EACA,sBAAA;AAFN;AAME;EACE,eAAA;EACA,eAAA;EACA,sBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,kCAAA;EACA,uBAAA;EACA,2BAAA;AALJ;;AASA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,qBAAA;AANF;AAQE;EACE,aAAA;AANJ;;AAUA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,kCAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0DAAA;AAPF;AASE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAPJ;AAUE;EACE,eAAA;EACA,cAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AARJ;AAWE;EACE,6BAAA;AATJ;AAYE;EACE,2BAAA;EACA,6BAAA;EACA,WAAA;AAVJ;AAYI;EACE,qCAAA;EACA,WAAA;AAVN;;AAeA;EACE,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AAZF;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAZF;AAcE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAZJ;AAeE;EACE,cAAA;AAbJ;AAgBE;EACE,iBAAA;EACA,oBAAA;EACA,iCAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AAdJ;;AAkBA;EACE;IACE,4BAAA;EAfF;EAkBA;IACE,kBAAA;EAhBF;EAmBA;IACE,uBAAA;EAjBF;AACF","sourcesContent":[":host {\n  --ap-brand: var(--fc-brand, #5ea1d8);\n  --ap-text: #212427;\n  --ap-muted: #667085;\n  --ap-border: #e4e7ec;\n  --ap-bg: #ffffff;\n  --ap-soft: #f6f8fa;\n  display: block;\n}\n\n:host-context(.theme-dark-layout),\n:host-context(body.theme-dark) {\n  --ap-text: #e6e8eb;\n  --ap-muted: #98a2b3;\n  --ap-border: #2f3542;\n  --ap-bg: #14171d;\n  --ap-soft: #232834;\n}\n\n::ng-deep .content-activity-dialog {\n  .mat-mdc-dialog-container,\n  .mat-dialog-container,\n  .mat-mdc-dialog-surface {\n    border-radius: 22px !important;\n    overflow: hidden !important;\n    padding: 0 !important;\n  }\n}\n\n.activity-panel {\n  display: flex;\n  flex-direction: column;\n  max-height: 88vh;\n  background: var(--ap-bg);\n  color: var(--ap-text);\n}\n\n.activity-header {\n  position: relative;\n  padding: 20px 56px 14px 24px;\n  border-bottom: 1px solid var(--ap-border);\n\n  h2 {\n    margin: 0;\n    font-size: 20px !important;\n    font-weight: 600;\n    color: var(--ap-text);\n    text-align: left;\n  }\n\n  .subtitle {\n    margin: 4px 0 0;\n    font-size: 14px;\n    color: var(--ap-text);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    .kind {\n      font-weight: 600;\n      color: var(--ap-brand);\n    }\n  }\n\n  .hint {\n    margin: 4px 0 0;\n    font-size: 12px;\n    color: var(--ap-muted);\n  }\n\n  button[mat-icon-button] {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    color: var(--ap-muted);\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n  }\n}\n\n.filters {\n  display: flex;\n  gap: 8px;\n  padding: 12px 24px;\n  border-bottom: 1px solid var(--ap-border);\n  overflow-x: auto;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.filter {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex: 0 0 auto;\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--ap-border);\n  background: transparent;\n  color: var(--ap-text);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n\n  .count {\n    min-width: 18px;\n    padding: 0 6px;\n    border-radius: 999px;\n    background: var(--ap-soft);\n    font-size: 11px;\n    font-weight: 600;\n    text-align: center;\n  }\n\n  &:hover {\n    border-color: var(--ap-brand);\n  }\n\n  &.active {\n    background: var(--ap-brand);\n    border-color: var(--ap-brand);\n    color: #fff;\n\n    .count {\n      background: rgba(255, 255, 255, 0.25);\n      color: #fff;\n    }\n  }\n}\n\n.activity-body {\n  padding: 16px 24px 24px;\n  overflow-y: auto;\n  flex: 1 1 auto;\n  background: var(--ap-soft);\n}\n\n.state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 40px 16px;\n  text-align: center;\n  color: var(--ap-muted);\n  font-size: 14px;\n\n  mat-icon {\n    font-size: 32px;\n    width: 32px;\n    height: 32px;\n  }\n\n  &--error mat-icon {\n    color: #f04438;\n  }\n\n  .retry {\n    padding: 6px 14px;\n    border-radius: 999px;\n    border: 1px solid var(--ap-brand);\n    background: transparent;\n    color: var(--ap-brand);\n    font-weight: 600;\n    cursor: pointer;\n  }\n}\n\n@media (max-width: 600px) {\n  .activity-header {\n    padding: 16px 48px 12px 16px;\n  }\n\n  .filters {\n    padding: 10px 16px;\n  }\n\n  .activity-body {\n    padding: 12px 12px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
